import { User, UserPermission, UserPermissionEnum } from "@/types/user";
import { TFunction } from "i18next";
import { ADMIN_ARRAY } from "./const";

export const getUserAvatarTip = (user: User) =>
  (user.name1 || user.name2 || user.mobile)?.slice(0, 3);
export const getUserName = (user: User) =>
  user.name1 || user.name2 || user.mobile;

export const getUserPermissionByOrg: (props: {
  orgId: string;
  path: string;
  permissions: Array<UserPermission>; // 拥有的全部permissions
  curPermissions: Array<UserPermissionEnum>; // 当前级别需要判断的
  upPermissions: Array<UserPermissionEnum>; // 上下级需要判断的
}) => boolean = ({
  path,
  orgId,
  permissions,
  upPermissions,
  curPermissions,
}) => {
    const upOrgIds = path?.split("#");
    upOrgIds?.pop(); // 去除自己的权限
    let hasPermission: boolean = false;

    let curPermissionInfo: Array<UserPermission> = [];
    let upPermissionInfo: Array<UserPermission> = [];
    permissions?.forEach((permission) => {
      if (permission.orgId) {
        if (permission.orgId === orgId) {
          curPermissionInfo.push(permission);
        } else if (upOrgIds?.includes(permission.orgId)) {
          upPermissionInfo.push(permission);
        }
      }
    });

    hasPermission =
      upPermissionInfo.some((per) => upPermissions?.includes(per.permission)) ||
      curPermissionInfo.some((per) => curPermissions?.includes(per.permission));
    return hasPermission;
  };

export const getCheckBoxData = (t: TFunction<"translation", undefined>) => {
  return [
    // {
    //   label: t("org.modifyOrgInfo"),
    //   value: UserPermissionEnum.MODIFY_ORG_INFO,
    // },
    // {
    //   label: t("org.addOrDisableOrgMember"),
    //   value: UserPermissionEnum.ADD_OR_DISABLE_ORG_MEMBER,
    // },
    // {
    //   label: t("org.orgMemberPermissions"),
    //   value: UserPermissionEnum.ORG_MEMBER_PERMISSIONS,
    // },
    // {
    //   label: t("warehouse.inboundOprt"),
    //   value: UserPermissionEnum.INBOUND_OPRT,
    // },
    // {
    //   label: t("warehouse.outboundOprt"),
    //   value: UserPermissionEnum.OUTBOUND_OPRT,
    // },
    // {
    //   label: t('layout.orderList'),
    //   value: UserPermissionEnum.ORDERE_LIST,
    // },
    // {
    //   label: t('counting.startInv'),
    //   value: UserPermissionEnum.STARTINV,
    // }
  ];
};

export const hasPermission = (
  user: User,
  permissions: UserPermissionEnum[],
  curOrg?: string | null
): boolean => {
  if (ADMIN_ARRAY.includes(user.mobile)) {
    return true; // 超级管理员直接通过
  }


  return user?.permissions?.some(({ orgId, permission }) => {
    if (orgId === null && permission === UserPermissionEnum.ADMIN) {
      return true;
    }
    return (
      permissions.includes(permission) &&
      (orgId === curOrg || orgId === null)
    );
  });
};

export const isAdmin = (user: User) => ADMIN_ARRAY.includes(user.mobile);